import platform from "platform";

const GEO_IP_URL = "https://ip2c.org/self";
const getUserLocation = () => {
  return fetch(GEO_IP_URL)
    .then(res => {
      if (res.status === 200) return res.text();
      throw new Error(`Invalid request for ${GEO_IP_URL}`);
    })
    .then(value => {
      const countryData = value ? value.split(";") : [];
      if (countryData && countryData.length >= 4) {
        const country = { name: countryData[3], code: countryData[1] };

        return country;
      }
      console.log("Country [Error]", { value });
      return null;
    })
    .catch(error => console.log("[Error] ", { error }));
};

export default getUserLocation;
